import type { BannerCampaignStatus } from '../models/banner-campaign.model'

export const BANNER_LIST_PAGE_SIZE = 10

export const BANNER_STATUS_LABEL: Record<BannerCampaignStatus, string> = {
    draft: 'Draft',
    submitted: 'Submitted',
    approved: 'Approved',
    rejected: 'Rejected',
    scheduled: 'Scheduled',
    active: 'Active',
    paused: 'Paused',
    ended: 'Ended',
}

export const BANNER_STATUS_CLASS: Record<BannerCampaignStatus, string> = {
    draft: 'status-chip status-chip--draft',
    submitted: 'status-chip status-chip--submitted',
    approved: 'status-chip status-chip--approved',
    rejected: 'status-chip status-chip--rejected',
    scheduled: 'status-chip status-chip--scheduled',
    active: 'status-chip status-chip--active',
    paused: 'status-chip status-chip--paused',
    ended: 'status-chip status-chip--ended',
}

export const BANNER_STATUS_OPTIONS: { value: BannerCampaignStatus | ''; label: string }[] = [
    { value: '', label: 'All' },
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'active', label: 'Active' },
    { value: 'paused', label: 'Paused' },
    { value: 'ended', label: 'Ended' },
]

export const BANNER_PLACEMENT_LABEL: Record<string, string> = {
    top_banner: 'Top banner',
    bottom_bar: 'Bottom bar',
    overlay_modal: 'Overlay / modal',
}

export const BANNER_LIST_COPY = {
    listTitle: 'EI Banner',
    listSubtitle: 'Create, schedule and manage banner campaigns on Ei applications.',
    createCta: 'Create banner',
    emptyTitle: 'No banner campaigns yet',
    emptySubtitle: 'Click "Create banner" to add your first campaign.',
    searchPlaceholder: 'Search by name…',
    previewTitle: 'Banner preview',
    previewTargetingTitle: 'Targeting',
    previewScheduleTitle: 'Schedule',
    rejectPrompt: 'Enter a rejection reason (minimum 10 characters):',
    rejectTooShort: 'Rejection reason must be at least 10 characters.',
    rejectTitle: 'Reject banner',
    rejectMessage:
        'Provide a reason for rejecting this campaign. This will be shared with the creator.',
    rejectConfirm: 'Reject',
    rejectRemarkLabel: 'Rejection reason',
    rejectRemarkPlaceholder: 'Enter at least 10 characters…',
    approveSuccess: 'Campaign approved.',
    rejectSuccess: 'Campaign rejected.',
    pauseSuccess: 'Campaign paused.',
    resumeSuccess: 'Campaign resumed.',
    startSuccessActive: 'Campaign is now active.',
    startSuccessScheduled: 'Campaign started successfully and is scheduled.',
    startSuccess: 'Campaign started successfully.',
    deleteSuccess: 'Campaign deleted.',
    deleteTitle: 'Delete banner',
    deleteConfirm: 'Delete this banner campaign? This cannot be undone.',
    deleteConfirmCta: 'Delete',
    actionFailed: 'Action failed. Please try again.',
    loadFailed: 'Failed to load banner campaigns. Please try again.',
    menuApprove: 'Approve',
    menuReject: 'Reject',
    menuPause: 'Pause',
    menuResume: 'Resume',
    menuStart: 'Start',
    menuEdit: 'Edit',
    menuDelete: 'Delete',
    pauseTitle: 'Pause banner',
    pauseConfirm: 'Pause this campaign? It will stop showing to eligible users until resumed.',
    pauseConfirmCta: 'Pause',
    resumeTitle: 'Resume banner',
    resumeConfirm: 'Resume this campaign? It will become available again based on its schedule.',
    resumeConfirmCta: 'Resume',
    startTitle: 'Start banner',
    startConfirm:
        'Start this campaign? It will become active or scheduled based on its start date.',
    startConfirmCta: 'Start',
} as const

/** Roles allowed to pause/resume campaigns. */
export const BANNER_PAUSE_RESUME_ROLES = new Set([
    'admin',
    'ei_admin',
    'super_admin',
    'super-admin',
    'superadmin',
])
